import type { StatementLineConfiguration } from "../../../../../../../../api/types/svTypes.ts";

type GraphLine = Pick<StatementLineConfiguration, "guid" | "level" | "lineType" | "lineIds" | "formulaParameters">;

export type FormulaCycleCandidate = Pick<StatementLineConfiguration, "guid" | "lineIds" | "formulaParameters"> & {
  lineType: "Total" | "Formula";
};

const dependencyIds = (lines: GraphLine[], candidate: FormulaCycleCandidate, guid: string): string[] => {
  if (guid === candidate.guid) {
    return candidate.lineType === "Total" ? candidate.lineIds : candidate.formulaParameters;
  }

  const line = lines.find((candidateLine) => candidateLine.guid === guid);
  if (!line) {
    return [];
  }

  switch (line.lineType) {
    case "Total":
      return line.lineIds;
    case "Formula":
      return line.formulaParameters;
    default:
      return [];
  }
};

export const findFormulaCycle = (lines: GraphLine[], candidate: FormulaCycleCandidate): string[] | undefined => {
  const stack: string[] = [];
  const visiting = new Set<string>();
  const done = new Set<string>();

  const visit = (guid: string): string[] | undefined => {
    if (done.has(guid)) {
      return undefined;
    }
    if (visiting.has(guid)) {
      return stack.slice(stack.indexOf(guid));
    }

    visiting.add(guid);
    stack.push(guid);

    for (const dependencyId of dependencyIds(lines, candidate, guid)) {
      const cycle = visit(dependencyId);
      if (cycle) {
        return cycle;
      }
    }

    stack.pop();
    done.add(guid);
    return undefined;
  };

  return visit(candidate.guid);
};
